export default {
  isAuthenticationError: function(response){
    return response && response.status === 401
  }
}
